/* istanbul ignore file */
export const clearFetchSessionState = (): void => {
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('businessCategories')
  sessionStorage.removeItem('vatRates')
  sessionStorage.removeItem('paymentProviders')
  sessionStorage.removeItem('privateCategories')
}
